import { render, staticRenderFns } from "./EmpresasComponent.vue?vue&type=template&id=4bd04bbc"
import script from "./EmpresasComponent.vue?vue&type=script&lang=js"
export * from "./EmpresasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports